import type { Enum } from '.';

export const BADGE_SHAPES = {
  ROUNDED: 'rounded',
  RHOMBUS: 'rhombus',
  NONE: 'none',
} as const;
export type BADGE_SHAPES = Enum<typeof BADGE_SHAPES>;

export const BADGE_FALLBACK = {
  CLUB_GENERIC_BADGE: 'club-generic-badge',
  NTC_GENERIC_BADGE_01: 'ntc-generic-badge-01',
  NTC_GENERIC_BADGE_02: 'ntc-generic-badge-02',
  NTC_GENERIC_BADGE_03: 'ntc-generic-badge-03',
  NTC_GENERIC_BADGE_04: 'ntc-generic-badge-04',
  UNL_GENERIC_BADGE: 'unl-generic-badge',
} as const;
export type BADGE_FALLBACK = Enum<typeof BADGE_FALLBACK>;
